import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-dvh bg-slate-50 flex items-center justify-center px-6">
      <div className="flex flex-col items-center gap-3" role="status">
        <div className="w-10 h-10 border-2 border-brand-700 border-t-transparent rounded-full animate-spin" />
        <span className="text-slate-500 text-sm font-medium">Loading…</span>
      </div>
    </div>
  );
  return user ? children : <Navigate to="/login" replace />;
}
